<template>
  <div class="vue3">
    <div id="app" class="pvflex flex" style="position:relative; line-height:1.5; font-family:Roboto, sans-serif">
      <PVToast postion="top-right"/>
      <NavigationToolBar id="navigation-toolbar">
        <router-view/>
      </NavigationToolBar>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import NavigationToolBar from "@/components/common/navigation/NavigationToolBar.vue";
import { useAppearanceStore } from "@/stores/appearance.ts";
import { useAuthStore } from "@/stores/authentication.ts";
import { useVersioningStore } from '@/stores/versioning.ts';
import { useSuccessStore } from '@/stores/success.ts';
import { useErrorsStore } from '@/stores/errors.ts';
import PVToast from 'primevue/toast';

export default defineComponent({
  name: 'App',
  components: { NavigationToolBar, PVToast },
  setup() {
    const versioningStore = useVersioningStore();
    const appearanceStore = useAppearanceStore();
    const authenticationStore = useAuthStore();
    const errorsStore = useErrorsStore();
    const successStore = useSuccessStore();
    return { versioningStore, appearanceStore, authenticationStore, errorsStore, successStore };
  },
  computed: {
    updateAvailable() {
      return this.versioningStore.updateAvailable;
    },
    errors() {
      if (!this.errorsStore.errors) return [];
      if (typeof this.errorsStore.errors != 'string') return this.errorsStore.errors;
      else return [this.errorsStore.errors];
    },
    messages() {
      if (!this.successStore.messages) return [];
      if (typeof this.successStore.messages != 'string') return this.successStore.messages;
      else return [this.successStore.messages];
    },
    isDark() {
      return this.appearanceStore.isDark;
    },
  },
  watch:{
    isDark() {
      document.documentElement.classList.toggle('ym-dark');
    },
    updateAvailable() {
      if (this.updateAvailable) {
        this.$toast.add({ severity:'info', summary: 'There is an update available. Please refresh the browser', life: 0, closable: false });
      }
    },
    errors() {
      for(const m of this.errors) {
        this.$toast.add({ severity:'error', summary: m, life: 5000 });
      }
      this.errorsStore.closeError();
    },
    messages() {
      for(const m of this.messages) {
        this.$toast.add({ severity:'success', summary: m, life: 5000 });
      }
      this.successStore.closeMessage();
    },
  },
});
</script>

<style scoped>

@media print {
 #navigation-toolbar {
        display: none;
        width: 0px;
    }
}

</style>
